import { defineStore } from 'pinia'

import { ref } from 'vue'

import { UiInstruction } from '../types'

export const useUiInstructionStore = defineStore('ui-instruction', () => {
	const uiInstruction = ref<Nullable<UiInstruction>>(null)
	const newInstruction = ref(true)

	const set = (instruction: UiInstruction) => {
		if (instruction) {
			newInstruction.value = true
		}

		uiInstruction.value = instruction
	}

	const getAndReset = () => {
		const instruction = (
			uiInstruction.value ? { ...uiInstruction.value } : null
		) as UiInstruction | null

		uiInstruction.value = null
		newInstruction.value = false
		return instruction
	}

	return {
		uiInstruction,
		newInstruction,
		set,
		getAndReset
	}
})
